var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowershipColorless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.94 329.68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Followership-colorless_svg__fil0",
    d: "M120.16 0c35.18 0 66.84 13.92 88.81 36.11C230.94 13.92 262.59 0 297.78 0c66.36 0 120.15 49.52 120.15 110.6 0 84.93-144.45 166.47-208.97 219.08C144.46 277.08-.02 195.54-.02 110.6-.02 49.52 53.77 0 120.14 0z"
  })));
}
export default SvgFollowershipColorless;